import { masterCountryCode } from "../interfaces/masterData";

export const COUNTRYCODES: masterCountryCode[] = [
  { cod_countryname: "South Georgia", cod_alpha2: "GS", cod_countrycode: "+500" },
  { cod_countryname: "Grenada", cod_alpha2: "GD", cod_countrycode: "+1473" },
  { cod_countryname: "Switzerland", cod_alpha2: "CH", cod_countrycode: "+41" },
  { cod_countryname: "Sierra Leone", cod_alpha2: "SL", cod_countrycode: "+232" },
  { cod_countryname: "Hungary", cod_alpha2: "HU", cod_countrycode: "+36" },
  { cod_countryname: "Taiwan", cod_alpha2: "TW", cod_countrycode: "+886" },
  { cod_countryname: "Wallis and Futuna", cod_alpha2: "WF", cod_countrycode: "+681" },
  { cod_countryname: "Barbados", cod_alpha2: "BB", cod_countrycode: "+1246" },
  { cod_countryname: "Pitcairn Islands", cod_alpha2: "PN", cod_countrycode: "+64" },
  { cod_countryname: "Ivory Coast", cod_alpha2: "CI", cod_countrycode: "+225" },
  { cod_countryname: "Tunisia", cod_alpha2: "TN", cod_countrycode: "+216" },
  { cod_countryname: "Italy", cod_alpha2: "IT", cod_countrycode: "+39" },
  { cod_countryname: "Benin", cod_alpha2: "BJ", cod_countrycode: "+229" },
  { cod_countryname: "Indonesia", cod_alpha2: "ID", cod_countrycode: "+62" },
  { cod_countryname: "Cape Verde", cod_alpha2: "CV", cod_countrycode: "+238" },
  { cod_countryname: "Saint Kitts and Nevis", cod_alpha2: "KN", cod_countrycode: "+1869" },
  { cod_countryname: "Laos", cod_alpha2: "LA", cod_countrycode: "+856" },
  { cod_countryname: "Caribbean Netherlands", cod_alpha2: "BQ", cod_countrycode: "+599" },
  { cod_countryname: "Uganda", cod_alpha2: "UG", cod_countrycode: "+256" },
  { cod_countryname: "Andorra", cod_alpha2: "AD", cod_countrycode: "+376" },
  { cod_countryname: "Burundi", cod_alpha2: "BI", cod_countrycode: "+257" },
  { cod_countryname: "South Africa", cod_alpha2: "ZA", cod_countrycode: "+27" },
  { cod_countryname: "France", cod_alpha2: "FR", cod_countrycode: "+33" },
  { cod_countryname: "Libya", cod_alpha2: "LY", cod_countrycode: "+218" },
  { cod_countryname: "Mexico", cod_alpha2: "MX", cod_countrycode: "+52" },
  { cod_countryname: "Gabon", cod_alpha2: "GA", cod_countrycode: "+241" },
  { cod_countryname: "Northern Mariana Islands", cod_alpha2: "MP", cod_countrycode: "+1670" },
  { cod_countryname: "North Macedonia", cod_alpha2: "MK", cod_countrycode: "+389" },
  { cod_countryname: "China", cod_alpha2: "CN", cod_countrycode: "+86" },
  { cod_countryname: "Yemen", cod_alpha2: "YE", cod_countrycode: "+967" },
  { cod_countryname: "Saint Barthélemy", cod_alpha2: "BL", cod_countrycode: "+590" },
  { cod_countryname: "Guernsey", cod_alpha2: "GG", cod_countrycode: "+44" },
  { cod_countryname: "Solomon Islands", cod_alpha2: "SB", cod_countrycode: "+677" },
  { cod_countryname: "Svalbard and Jan Mayen", cod_alpha2: "SJ", cod_countrycode: "+4779" },
  { cod_countryname: "Faroe Islands", cod_alpha2: "FO", cod_countrycode: "+298" },
  { cod_countryname: "Uzbekistan", cod_alpha2: "UZ", cod_countrycode: "+998" },
  { cod_countryname: "Egypt", cod_alpha2: "EG", cod_countrycode: "+20" },
  { cod_countryname: "Senegal", cod_alpha2: "SN", cod_countrycode: "+221" },
  { cod_countryname: "Sri Lanka", cod_alpha2: "LK", cod_countrycode: "+94" },
  { cod_countryname: "Palestine", cod_alpha2: "PS", cod_countrycode: "+970" },
  { cod_countryname: "Bangladesh", cod_alpha2: "BD", cod_countrycode: "+880" },
  { cod_countryname: "Peru", cod_alpha2: "PE", cod_countrycode: "+51" },
  { cod_countryname: "Singapore", cod_alpha2: "SG", cod_countrycode: "+65" },
  { cod_countryname: "Turkey", cod_alpha2: "TR", cod_countrycode: "+90" },
  { cod_countryname: "Afghanistan", cod_alpha2: "AF", cod_countrycode: "+93" },
  { cod_countryname: "Aruba", cod_alpha2: "AW", cod_countrycode: "+297" },
  { cod_countryname: "Cook Islands", cod_alpha2: "CK", cod_countrycode: "+682" },
  { cod_countryname: "United Kingdom", cod_alpha2: "GB", cod_countrycode: "+44" },
  { cod_countryname: "Zambia", cod_alpha2: "ZM", cod_countrycode: "+260" },
  { cod_countryname: "Finland", cod_alpha2: "FI", cod_countrycode: "+358" },
  { cod_countryname: "Niger", cod_alpha2: "NE", cod_countrycode: "+227" },
  { cod_countryname: "Christmas Island", cod_alpha2: "CX", cod_countrycode: "+61" },
  { cod_countryname: "Tokelau", cod_alpha2: "TK", cod_countrycode: "+690" },
  { cod_countryname: "Guinea-Bissau", cod_alpha2: "GW", cod_countrycode: "+245" },
  { cod_countryname: "Azerbaijan", cod_alpha2: "AZ", cod_countrycode: "+994" },
  { cod_countryname: "Réunion", cod_alpha2: "RE", cod_countrycode: "+262" },
  { cod_countryname: "Djibouti", cod_alpha2: "DJ", cod_countrycode: "+253" },
  { cod_countryname: "North Korea", cod_alpha2: "KP", cod_countrycode: "+850" },
  { cod_countryname: "Mauritius", cod_alpha2: "MU", cod_countrycode: "+230" },
  { cod_countryname: "Montserrat", cod_alpha2: "MS", cod_countrycode: "+1664" },
  { cod_countryname: "United States Virgin Islands", cod_alpha2: "VI", cod_countrycode: "+1340" },
  { cod_countryname: "Colombia", cod_alpha2: "CO", cod_countrycode: "+57" },
  { cod_countryname: "Greece", cod_alpha2: "GR", cod_countrycode: "+30" },
  { cod_countryname: "Croatia", cod_alpha2: "HR", cod_countrycode: "+385" },
  { cod_countryname: "Morocco", cod_alpha2: "MA", cod_countrycode: "+212" },
  { cod_countryname: "Algeria", cod_alpha2: "DZ", cod_countrycode: "+213" },
  { cod_countryname: "Netherlands", cod_alpha2: "NL", cod_countrycode: "+31" },
  { cod_countryname: "Sudan", cod_alpha2: "SD", cod_countrycode: "+249" },
  { cod_countryname: "Fiji", cod_alpha2: "FJ", cod_countrycode: "+679" },
  { cod_countryname: "Liechtenstein", cod_alpha2: "LI", cod_countrycode: "+423" },
  { cod_countryname: "Nepal", cod_alpha2: "NP", cod_countrycode: "+977" },
  { cod_countryname: "Puerto Rico", cod_alpha2: "PR", cod_countrycode: "+1787" },
  { cod_countryname: "Georgia", cod_alpha2: "GE", cod_countrycode: "+995" },
  { cod_countryname: "Pakistan", cod_alpha2: "PK", cod_countrycode: "+92" },
  { cod_countryname: "Monaco", cod_alpha2: "MC", cod_countrycode: "+377" },
  { cod_countryname: "Botswana", cod_alpha2: "BW", cod_countrycode: "+267" },
  { cod_countryname: "Lebanon", cod_alpha2: "LB", cod_countrycode: "+961" },
  { cod_countryname: "Papua New Guinea", cod_alpha2: "PG", cod_countrycode: "+675" },
  { cod_countryname: "Mayotte", cod_alpha2: "YT", cod_countrycode: "+262" },
  { cod_countryname: "Dominican Republic", cod_alpha2: "DO", cod_countrycode: "+1809" },
  { cod_countryname: "Norfolk Island", cod_alpha2: "NF", cod_countrycode: "+672" },
  { cod_countryname: "Bouvet Island", cod_alpha2: "BV", cod_countrycode: "+47" },
  { cod_countryname: "Qatar", cod_alpha2: "QA", cod_countrycode: "+974" },
  { cod_countryname: "Madagascar", cod_alpha2: "MG", cod_countrycode: "+261" },
  { cod_countryname: "India", cod_alpha2: "IN", cod_countrycode: "+91" },
  { cod_countryname: "Syria", cod_alpha2: "SY", cod_countrycode: "+963" },
  { cod_countryname: "Montenegro", cod_alpha2: "ME", cod_countrycode: "+382" },
  { cod_countryname: "Eswatini", cod_alpha2: "SZ", cod_countrycode: "+268" },
  { cod_countryname: "Paraguay", cod_alpha2: "PY", cod_countrycode: "+595" },
  { cod_countryname: "El Salvador", cod_alpha2: "SV", cod_countrycode: "+503" },
  { cod_countryname: "Ukraine", cod_alpha2: "UA", cod_countrycode: "+380" },
  { cod_countryname: "Isle of Man", cod_alpha2: "IM", cod_countrycode: "+44" },
  { cod_countryname: "Namibia", cod_alpha2: "NA", cod_countrycode: "+264" },
  { cod_countryname: "United Arab Emirates", cod_alpha2: "AE", cod_countrycode: "+971" },
  { cod_countryname: "Bulgaria", cod_alpha2: "BG", cod_countrycode: "+359" },
  { cod_countryname: "Greenland", cod_alpha2: "GL", cod_countrycode: "+299" },
  { cod_countryname: "Germany", cod_alpha2: "DE", cod_countrycode: "+49" },
  { cod_countryname: "Cambodia", cod_alpha2: "KH", cod_countrycode: "+855" },
  { cod_countryname: "Iraq", cod_alpha2: "IQ", cod_countrycode: "+964" },
  { cod_countryname: "French Southern and Antarctic Lands", cod_alpha2: "TF", cod_countrycode: "+262" },
  { cod_countryname: "Sweden", cod_alpha2: "SE", cod_countrycode: "+46" },
  { cod_countryname: "Cuba", cod_alpha2: "CU", cod_countrycode: "+53" },
  { cod_countryname: "Kyrgyzstan", cod_alpha2: "KG", cod_countrycode: "+996" },
  { cod_countryname: "Russia", cod_alpha2: "RU", cod_countrycode: "+73" },
  { cod_countryname: "Malaysia", cod_alpha2: "MY", cod_countrycode: "+60" },
  { cod_countryname: "São Tomé and Príncipe", cod_alpha2: "ST", cod_countrycode: "+239" },
  { cod_countryname: "Cyprus", cod_alpha2: "CY", cod_countrycode: "+357" },
  { cod_countryname: "Canada", cod_alpha2: "CA", cod_countrycode: "+1" },
  { cod_countryname: "Malawi", cod_alpha2: "MW", cod_countrycode: "+265" },
  { cod_countryname: "Saudi Arabia", cod_alpha2: "SA", cod_countrycode: "+966" },
  { cod_countryname: "Bosnia and Herzegovina", cod_alpha2: "BA", cod_countrycode: "+387" },
  { cod_countryname: "Ethiopia", cod_alpha2: "ET", cod_countrycode: "+251" },
  { cod_countryname: "Spain", cod_alpha2: "ES", cod_countrycode: "+34" },
  { cod_countryname: "Slovenia", cod_alpha2: "SI", cod_countrycode: "+386" },
  { cod_countryname: "Oman", cod_alpha2: "OM", cod_countrycode: "+968" },
  { cod_countryname: "Saint Pierre and Miquelon", cod_alpha2: "PM", cod_countrycode: "+508" },
  { cod_countryname: "Macau", cod_alpha2: "MO", cod_countrycode: "+853" },
  { cod_countryname: "San Marino", cod_alpha2: "SM", cod_countrycode: "+378" },
  { cod_countryname: "Lesotho", cod_alpha2: "LS", cod_countrycode: "+266" },
  { cod_countryname: "Marshall Islands", cod_alpha2: "MH", cod_countrycode: "+692" },
  { cod_countryname: "Sint Maarten", cod_alpha2: "SX", cod_countrycode: "+1721" },
  { cod_countryname: "Iceland", cod_alpha2: "IS", cod_countrycode: "+354" },
  { cod_countryname: "Luxembourg", cod_alpha2: "LU", cod_countrycode: "+352" },
  { cod_countryname: "Argentina", cod_alpha2: "AR", cod_countrycode: "+54" },
  { cod_countryname: "Turks and Caicos Islands", cod_alpha2: "TC", cod_countrycode: "+1649" },
  { cod_countryname: "Nauru", cod_alpha2: "NR", cod_countrycode: "+674" },
  { cod_countryname: "Cocos (Keeling) Islands", cod_alpha2: "CC", cod_countrycode: "+61" },
  { cod_countryname: "Western Sahara", cod_alpha2: "EH", cod_countrycode: "+2125288" },
  { cod_countryname: "Dominica", cod_alpha2: "DM", cod_countrycode: "+1767" },
  { cod_countryname: "Costa Rica", cod_alpha2: "CR", cod_countrycode: "+506" },
  { cod_countryname: "Australia", cod_alpha2: "AU", cod_countrycode: "+61" },
  { cod_countryname: "Thailand", cod_alpha2: "TH", cod_countrycode: "+66" },
  { cod_countryname: "Haiti", cod_alpha2: "HT", cod_countrycode: "+509" },
  { cod_countryname: "Tuvalu", cod_alpha2: "TV", cod_countrycode: "+688" },
  { cod_countryname: "Honduras", cod_alpha2: "HN", cod_countrycode: "+504" },
  { cod_countryname: "Equatorial Guinea", cod_alpha2: "GQ", cod_countrycode: "+240" },
  { cod_countryname: "Saint Lucia", cod_alpha2: "LC", cod_countrycode: "+1758" },
  { cod_countryname: "French Polynesia", cod_alpha2: "PF", cod_countrycode: "+689" },
  { cod_countryname: "Belarus", cod_alpha2: "BY", cod_countrycode: "+375" },
  { cod_countryname: "Latvia", cod_alpha2: "LV", cod_countrycode: "+371" },
  { cod_countryname: "Palau", cod_alpha2: "PW", cod_countrycode: "+680" },
  { cod_countryname: "Guadeloupe", cod_alpha2: "GP", cod_countrycode: "+590" },
  { cod_countryname: "Philippines", cod_alpha2: "PH", cod_countrycode: "+63" },
  { cod_countryname: "Gibraltar", cod_alpha2: "GI", cod_countrycode: "+350" },
  { cod_countryname: "Denmark", cod_alpha2: "DK", cod_countrycode: "+45" },
  { cod_countryname: "Cameroon", cod_alpha2: "CM", cod_countrycode: "+237" },
  { cod_countryname: "Guinea", cod_alpha2: "GN", cod_countrycode: "+224" },
  { cod_countryname: "Bahrain", cod_alpha2: "BH", cod_countrycode: "+973" },
  { cod_countryname: "Suriname", cod_alpha2: "SR", cod_countrycode: "+597" },
  { cod_countryname: "DR Congo", cod_alpha2: "CD", cod_countrycode: "+243" },
  { cod_countryname: "Somalia", cod_alpha2: "SO", cod_countrycode: "+252" },
  { cod_countryname: "Czechia", cod_alpha2: "CZ", cod_countrycode: "+420" },
  { cod_countryname: "New Caledonia", cod_alpha2: "NC", cod_countrycode: "+687" },
  { cod_countryname: "Vanuatu", cod_alpha2: "VU", cod_countrycode: "+678" },
  { cod_countryname: "Saint Helena, Ascension and Tristan da Cunha", cod_alpha2: "SH", cod_countrycode: "+290" },
  { cod_countryname: "Togo", cod_alpha2: "TG", cod_countrycode: "+228" },
  { cod_countryname: "British Virgin Islands", cod_alpha2: "VG", cod_countrycode: "+1284" },
  { cod_countryname: "Kenya", cod_alpha2: "KE", cod_countrycode: "+254" },
  { cod_countryname: "Niue", cod_alpha2: "NU", cod_countrycode: "+683" },
  { cod_countryname: "Rwanda", cod_alpha2: "RW", cod_countrycode: "+250" },
  { cod_countryname: "Estonia", cod_alpha2: "EE", cod_countrycode: "+372" },
  { cod_countryname: "Romania", cod_alpha2: "RO", cod_countrycode: "+40" },
  { cod_countryname: "Trinidad and Tobago", cod_alpha2: "TT", cod_countrycode: "+1868" },
  { cod_countryname: "Guyana", cod_alpha2: "GY", cod_countrycode: "+592" },
  { cod_countryname: "Timor-Leste", cod_alpha2: "TL", cod_countrycode: "+670" },
  { cod_countryname: "Vietnam", cod_alpha2: "VN", cod_countrycode: "+84" },
  { cod_countryname: "Uruguay", cod_alpha2: "UY", cod_countrycode: "+598" },
  { cod_countryname: "Vatican City", cod_alpha2: "VA", cod_countrycode: "+3906698" },
  { cod_countryname: "Hong Kong", cod_alpha2: "HK", cod_countrycode: "+852" },
  { cod_countryname: "Austria", cod_alpha2: "AT", cod_countrycode: "+43" },
  { cod_countryname: "Antigua and Barbuda", cod_alpha2: "AG", cod_countrycode: "+1268" },
  { cod_countryname: "Turkmenistan", cod_alpha2: "TM", cod_countrycode: "+993" },
  { cod_countryname: "Mozambique", cod_alpha2: "MZ", cod_countrycode: "+258" },
  { cod_countryname: "Panama", cod_alpha2: "PA", cod_countrycode: "+507" },
  { cod_countryname: "Micronesia", cod_alpha2: "FM", cod_countrycode: "+691" },
  { cod_countryname: "Ireland", cod_alpha2: "IE", cod_countrycode: "+353" },
  { cod_countryname: "Curaçao", cod_alpha2: "CW", cod_countrycode: "+599" },
  { cod_countryname: "French Guiana", cod_alpha2: "GF", cod_countrycode: "+594" },
  { cod_countryname: "Norway", cod_alpha2: "NO", cod_countrycode: "+47" },
  { cod_countryname: "Åland Islands", cod_alpha2: "AX", cod_countrycode: "+35818" },
  { cod_countryname: "Central African Republic", cod_alpha2: "CF", cod_countrycode: "+236" },
  { cod_countryname: "Burkina Faso", cod_alpha2: "BF", cod_countrycode: "+226" },
  { cod_countryname: "Eritrea", cod_alpha2: "ER", cod_countrycode: "+291" },
  { cod_countryname: "Tanzania", cod_alpha2: "TZ", cod_countrycode: "+255" },
  { cod_countryname: "South Korea", cod_alpha2: "KR", cod_countrycode: "+82" },
  { cod_countryname: "Jordan", cod_alpha2: "JO", cod_countrycode: "+962" },
  { cod_countryname: "Mauritania", cod_alpha2: "MR", cod_countrycode: "+222" },
  { cod_countryname: "Lithuania", cod_alpha2: "LT", cod_countrycode: "+370" },
  { cod_countryname: "United States Minor Outlying Islands", cod_alpha2: "UM", cod_countrycode: "+268" },
  { cod_countryname: "Slovakia", cod_alpha2: "SK", cod_countrycode: "+421" },
  { cod_countryname: "Angola", cod_alpha2: "AO", cod_countrycode: "+244" },
  { cod_countryname: "Kazakhstan", cod_alpha2: "KZ", cod_countrycode: "+76" },
  { cod_countryname: "Moldova", cod_alpha2: "MD", cod_countrycode: "+373" },
  { cod_countryname: "Mali", cod_alpha2: "ML", cod_countrycode: "+223" },
  { cod_countryname: "Falkland Islands", cod_alpha2: "FK", cod_countrycode: "+500" },
  { cod_countryname: "Armenia", cod_alpha2: "AM", cod_countrycode: "+374" },
  { cod_countryname: "Samoa", cod_alpha2: "WS", cod_countrycode: "+685" },
  { cod_countryname: "Jersey", cod_alpha2: "JE", cod_countrycode: "+44" },
  { cod_countryname: "Japan", cod_alpha2: "JP", cod_countrycode: "+81" },
  { cod_countryname: "Bolivia", cod_alpha2: "BO", cod_countrycode: "+591" },
  { cod_countryname: "Chile", cod_alpha2: "CL", cod_countrycode: "+56" },
  { cod_countryname: "United States", cod_alpha2: "US", cod_countrycode: "+1201" },
  { cod_countryname: "Saint Vincent and the Grenadines", cod_alpha2: "VC", cod_countrycode: "+1784" },
  { cod_countryname: "Bermuda", cod_alpha2: "BM", cod_countrycode: "+1441" },
  { cod_countryname: "Seychelles", cod_alpha2: "SC", cod_countrycode: "+248" },
  { cod_countryname: "British Indian Ocean Territory", cod_alpha2: "IO", cod_countrycode: "+246" },
  { cod_countryname: "Guatemala", cod_alpha2: "GT", cod_countrycode: "+502" },
  { cod_countryname: "Ecuador", cod_alpha2: "EC", cod_countrycode: "+593" },
  { cod_countryname: "Martinique", cod_alpha2: "MQ", cod_countrycode: "+596" },
  { cod_countryname: "Tajikistan", cod_alpha2: "TJ", cod_countrycode: "+992" },
  { cod_countryname: "Malta", cod_alpha2: "MT", cod_countrycode: "+356" },
  { cod_countryname: "Gambia", cod_alpha2: "GM", cod_countrycode: "+220" },
  { cod_countryname: "Nigeria", cod_alpha2: "NG", cod_countrycode: "+234" },
  { cod_countryname: "Bahamas", cod_alpha2: "BS", cod_countrycode: "+1242" },
  { cod_countryname: "Kosovo", cod_alpha2: "XK", cod_countrycode: "+383" },
  { cod_countryname: "Kuwait", cod_alpha2: "KW", cod_countrycode: "+965" },
  { cod_countryname: "Maldives", cod_alpha2: "MV", cod_countrycode: "+960" },
  { cod_countryname: "South Sudan", cod_alpha2: "SS", cod_countrycode: "+211" },
  { cod_countryname: "Iran", cod_alpha2: "IR", cod_countrycode: "+98" },
  { cod_countryname: "Albania", cod_alpha2: "AL", cod_countrycode: "+355" },
  { cod_countryname: "Brazil", cod_alpha2: "BR", cod_countrycode: "+55" },
  { cod_countryname: "Serbia", cod_alpha2: "RS", cod_countrycode: "+381" },
  { cod_countryname: "Belize", cod_alpha2: "BZ", cod_countrycode: "+501" },
  { cod_countryname: "Myanmar", cod_alpha2: "MM", cod_countrycode: "+95" },
  { cod_countryname: "Bhutan", cod_alpha2: "BT", cod_countrycode: "+975" },
  { cod_countryname: "Venezuela", cod_alpha2: "VE", cod_countrycode: "+58" },
  { cod_countryname: "Liberia", cod_alpha2: "LR", cod_countrycode: "+231" },
  { cod_countryname: "Jamaica", cod_alpha2: "JM", cod_countrycode: "+1876" },
  { cod_countryname: "Poland", cod_alpha2: "PL", cod_countrycode: "+48" },
  { cod_countryname: "Cayman Islands", cod_alpha2: "KY", cod_countrycode: "+1345" },
  { cod_countryname: "Brunei", cod_alpha2: "BN", cod_countrycode: "+673" },
  { cod_countryname: "Comoros", cod_alpha2: "KM", cod_countrycode: "+269" },
  { cod_countryname: "Guam", cod_alpha2: "GU", cod_countrycode: "+1671" },
  { cod_countryname: "Tonga", cod_alpha2: "TO", cod_countrycode: "+676" },
  { cod_countryname: "Kiribati", cod_alpha2: "KI", cod_countrycode: "+686" },
  { cod_countryname: "Ghana", cod_alpha2: "GH", cod_countrycode: "+233" },
  { cod_countryname: "Chad", cod_alpha2: "TD", cod_countrycode: "+235" },
  { cod_countryname: "Zimbabwe", cod_alpha2: "ZW", cod_countrycode: "+263" },
  { cod_countryname: "Saint Martin", cod_alpha2: "MF", cod_countrycode: "+590" },
  { cod_countryname: "Mongolia", cod_alpha2: "MN", cod_countrycode: "+976" },
  { cod_countryname: "Portugal", cod_alpha2: "PT", cod_countrycode: "+351" },
  { cod_countryname: "American Samoa", cod_alpha2: "AS", cod_countrycode: "+1684" },
  { cod_countryname: "Republic of the Congo", cod_alpha2: "CG", cod_countrycode: "+242" },
  { cod_countryname: "Belgium", cod_alpha2: "BE", cod_countrycode: "+32" },
  { cod_countryname: "Israel", cod_alpha2: "IL", cod_countrycode: "+972" },
  { cod_countryname: "New Zealand", cod_alpha2: "NZ", cod_countrycode: "+64" },
  { cod_countryname: "Nicaragua", cod_alpha2: "NI", cod_countrycode: "+505" },
  { cod_countryname: "Anguilla", cod_alpha2: "AI", cod_countrycode: "+1264" },
];